import { map, Observable } from "rxjs";
import { apiService } from "../../ApiService";
import { Subscription } from "../../../model";

/**
 * @deprecated use getFamilyInfo
 * @returns
 */
export const getFamilySubscription = (): Observable<Subscription> => {
  return apiService
    .get<{ subscription: Subscription }>({
      path: `v1/family`,
      requiresAuthPolicy: "family",
    })
    .pipe(map(({ subscription }) => subscription));
};
